import React from "react";
import { connect } from "react-redux";
import { Switch, Route, Link } from "react-router-dom";
import { Button } from "react-bootstrap";
import AddProfile from "./AddProfile";
import Address from "./Address";
import PlacedOrder from "./PlacedOrder";
import ChangePassword from "./ChangePassword";

function Profile(props) {
  return (
    <div className="container row mx-auto my-3">
      <div className="col-md-3">
        <div className="text-center">
          <p className="py-2 text-white" style={{ backgroundColor: "#e8491d" }}>
            Welcome {props.username}
          </p>
          <div>
            <div className="mb-1">
              <Link to="/profile">
                <Button variant="dark" className="px-4 w-100">
                  Profile
                </Button>
              </Link>
            </div>
            <div className="mb-1">
              <Link to="/profile/address">
                <Button variant="dark" className="px-4 w-100">
                  Address
                </Button>
              </Link>
            </div>
            <div className="mb-1">
              <Link to="/profile/orders">
                <Button variant="dark" className="px-4 w-100">
                  Your Order's
                </Button>
              </Link>
            </div>
            <div className="mb-1">
              <Link to="/profile/cpass">
                <Button variant="dark" className="px-4 w-100">
                  Change Password
                </Button>
              </Link>
            </div>
          </div>
        </div>
      </div>
      <div
        className="col-md-9 mt-4 mt-md-0"
        style={{ borderLeft: "2px solid gray" }}
      >
        <Switch>
          <Route
            exact
            path="/profile"
            render={(props) => <AddProfile {...props} />}
          />
          <Route
            path="/profile/address"
            render={(props) => <Address {...props} />}
          />
          <Route
            exact
            path="/profile/orders"
            render={(props) => <PlacedOrder {...props} />}
          />
          <Route
            exact
            path="/profile/cpass"
            render={(props) => <ChangePassword {...props} />}
          />
        </Switch>
      </div>
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    username: state.userDetails.username ? state.userDetails.username : null,
  };
};
export default connect(mapStateToProps)(Profile);
